import React from 'react';
import { Button } from './Button';
import styles from './LiveChatClosedInTab.module.css';
import liveChatConfig from '../resources/liveChatConfig.json';

import { AmpFlagSet } from '../amplitude';

export const LiveChatClosedInTab: React.FC<{
    featureFlags: AmpFlagSet;
}> = ({ featureFlags }) => {
    return (
        <div className={styles.liveChatClosedInTabContainer}>
            <div className={styles.liveChatClosedInTabHeader}>
                {liveChatConfig.providence.chatActiveOtherTab}
            </div>
            <div className={styles.liveChatClosedInTabBody}>
                {liveChatConfig.providence.wantToTransfer}
            </div>
            <div className={styles.liveChatClosedInTabButtonContainer}>
                <Button
                    disableButtons={false}
                    featureFlags={featureFlags}
                    onClick={() => window.location.reload()}
                    button={{
                        title: liveChatConfig.providence.transferLiveChat,
                    }}
                />
            </div>
        </div>
    );
};
